import { Fragment } from "react";

function SuccessSignup() {
    return <Fragment></Fragment>;
}

export default SuccessSignup;
